// Convert to base64
export const getBase64 = (bytes) => {
  let data = '';

  // Produce binary string from bytes in buffer
  for (let i = 0; i < bytes.byteLength; i++) {
    data += String.fromCharCode(bytes[i]);
  }

  // Convert to base64
  return window.btoa(data);
};

export default getBase64;



// WEBPACK FOOTER //
// ./src/common/utils/getBase64.js